// True when the frontend should display development markers (dev tab title,
// amber favicon, hazard ribbon, DEV badges).
//
// Controlled by REACT_APP_ENV, which you set per deployment:
//   REACT_APP_ENV=development  -> markers shown
//   REACT_APP_ENV=production   -> markers hidden
//
// The local `npm start` dev server always shows them (NODE_ENV === development),
// regardless of REACT_APP_ENV.
//
// NOTE: these are build-time variables in Create React App — the value present
// when `npm run build` runs is baked into the bundle. Changing .env afterwards
// has no effect until you rebuild.
export const IS_DEV_ENV =
  process.env.NODE_ENV === "development" ||
  process.env.REACT_APP_ENV === "development";
